<template>
  <div>
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['product_details'][StoreLang] }}
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">
          <template v-if="d_loading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            <b-row class="font-size-base" v-if="d_bundleData">
              <b-col sm="12" lg="8">
                <b-row class="mb-3-75">
                  <b-col sm="12" md="12" lg="6">
                    <div class="category-tag-style">
                      <strong> {{ d_bundleData.data['0']['10']['lang'][StoreLang].toLocaleUpperCase() }}</strong>
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col sm="12" lg="12">
                    <div class="bundle-title-box-style">
                      <h2 class="bundle-title-h2-style">
                        {{ d_bundleData.data['0']['1']['lang'][StoreLang].toLocaleUpperCase() }} <span v-if="d_bundleData.data['0']['77'] && d_bundleData.data['0']['77']['val']" style="font-size: 16px">[{{ d_bundleData.data['0']['77']['val'] }}]</span>
                      </h2>
                    </div>
                  </b-col>
                </b-row>

                <template v-if="d_bundleProductList.length > 0">
                  <b-row class="mt-5 mb-2-5">
                    <b-col cols="12">
                      <div class="section-header-style">
                        <i class="fa fa-angle-right section-icon-style"></i>
                        <strong class="font-weight-bold-important"> {{ StoreLangTranslation.data['product_list'][StoreLang] }}</strong>
                      </div>
                    </b-col>
                  </b-row>
                  <template v-for="(product_item, product_item_index) in d_bundleProductList" v-if="f_showCheckProduct(product_item.product)">
                    <b-row class="product-item-row-style">
                      <b-col sm="12" lg="9" class="text-align-left">
                        <i class="fa fa-angle-double-right product-icon-style"></i>
                        <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['1'] && product_item.product.data['0']['1']['lang'] && product_item.product.data['0']['1']['lang'][StoreLang]">
                          <small class="text-color-dark-gray"> {{ product_item.product.data['0']['1']['lang'][StoreLang] }}</small>
                        </template>
                        <template v-else-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['1'] && product_item.product.data['0']['1']['val']">
                          <small class="text-color-dark-gray"> {{ product_item.product.data['0']['1']['val'] }}</small>
                        </template>
                      </b-col>
                      <b-col sm="12" lg="3" class="text-align-right">
                        <template v-if="d_institutionalDiscounts || d_userShopBundleClientID in d_bundleDiscounts">
                          <!-- <strong class="price-style">{{ f_calculateProductTotalPrice([product_item]) }}</strong> -->
                          <strong class="price-style">{{ f_calculateProductTotalPriceWithDiscount([product_item]) }}</strong>
                          
                        </template>
                        <template v-if="d_bundleData.data['0']['13'] && d_bundleData.data['0']['13']['val']['value'] === '1'">
                          <strong :class="d_institutionalDiscounts || d_userShopBundleClientID in d_bundleDiscounts ? 'price-style underlined-price' : 'price-style'">{{ f_calculateProductTotalPrice([product_item]) }}</strong>
                        </template>
                      </b-col>
                    </b-row>
                  </template>
                </template>

                <template v-if="d_bundleData.data['0']['2'] && d_bundleData.data['0']['2'].list && d_bundleData.data['0']['2'].list.length > 0">
                  <b-row class="mt-5 mb-2-5">
                    <b-col cols="12">
                      <div class="section-header-style">
                        <i class="fa fa-angle-right section-icon-style"></i>
                        <strong class="font-weight-bold-important"> {{ StoreLangTranslation.data['highlights'][StoreLang] }}</strong>
                      </div>
                    </b-col>
                  </b-row>
                  <template v-for="(feature_item, feature_item_index) in d_bundleData.data['0']['2']['list']">
                    <template v-if="feature_item['11'] && feature_item['11'].val && feature_item['11'].val.value && ['1'].indexOf(feature_item['11'].val.value) !== -1">
                      <b-row class="feature-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-check-circle feature-highlight-icon"></i>
                          <small class="text-color-dark-gray"> {{ feature_item['3']['lang'][StoreLang] }} </small>
                        </b-col>
                      </b-row>
                    </template>
                  </template>

                  <b-row v-if="d_bundleData.data['0']['2']['list'].some(item => item['11'] && item['11'].val && item['11'].val.value && ['0','3'].includes(item['11'].val.value))" class="mt-5 mb-2-5">
                    <b-col cols="12">
                      <div class="section-header-style">
                        <i class="fa fa-angle-right section-icon-style"></i>
                        <strong class="font-weight-bold-important"> {{ StoreLangTranslation.data['general_features'][StoreLang] }}</strong>
                      </div>
                    </b-col>
                  </b-row>
                  <template v-for="(feature_item, feature_item_index) in d_bundleData.data['0']['2']['list']">
                    <template v-if="feature_item['11'] && feature_item['11'].val && feature_item['11'].val.value && ['0', '3'].indexOf(feature_item['11'].val.value) !== -1">
                      <b-row class="feature-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-asterisk feature-general-icon"></i>
                          <small v-if="['0'].indexOf(feature_item['11'].val.value) !== -1" class="text-color-dark-gray"> {{ feature_item['3']['lang'][StoreLang] }} </small>
                          <small v-if="['3'].indexOf(feature_item['11'].val.value) !== -1" class="font-size-base">
                            <a href="https://docs.wisdomera.io" class="link-style"> {{ feature_item['3']['lang'][StoreLang] }}</a>
                          </small>
                        </b-col>
                      </b-row>
                    </template>
                  </template>
                  
                  <b-row v-if="d_bundleData.data['0']['2']['list'].some(item => item['11'] && item['11'].val && item['11'].val.value && item['11'].val.value === '2')" class="mt-5 mb-2-5">
                    <b-col cols="12">
                      <div class="section-header-style">
                        <i class="fa fa-angle-right section-icon-style"></i>
                        <strong class="font-weight-bold-important"> {{ StoreLangTranslation.data['customer_experience'][StoreLang] }}</strong>
                      </div>
                    </b-col>
                  </b-row>
                  <template v-for="(feature_item, feature_item_index) in d_bundleData.data['0']['2']['list']">
                    <template v-if="feature_item['11'] && feature_item['11'].val && feature_item['11'].val.value && ['2'].indexOf(feature_item['11'].val.value) !== -1">
                      <b-row class="feature-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-thumbs-up feature-highlight-icon"></i>
                          <small class="text-color-dark-gray"> {{ feature_item['3']['lang'][StoreLang] }} </small>
                        </b-col>
                      </b-row>
                    </template>
                  </template>

                  <b-row v-if="d_bundleData.data['0']['2']['list'].some(item => item['11'] && item['11'].val && item['11'].val.value && item['11'].val.value === '4')" class="mt-5 mb-2-5">
                    <b-col cols="12">
                      <div class="section-header-style">
                        <i class="fa fa-angle-right section-icon-style"></i>
                        <strong class="font-weight-bold-important"> {{ StoreLangTranslation.data['who_can_use'][StoreLang] }}</strong>
                      </div>
                    </b-col>
                  </b-row>
                  <template v-for="(feature_item, feature_item_index) in d_bundleData.data['0']['2']['list']">
                    <template v-if="feature_item['11'] && feature_item['11'].val && feature_item['11'].val.value && ['4'].indexOf(feature_item['11'].val.value) !== -1">
                      <b-row class="feature-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-users feature-highlight-icon"></i>
                          <!-- <i class="fa fa-angle-double-right product-icon-style"></i> -->
                          <small class="text-color-dark-gray"> {{ feature_item['3']['lang'][StoreLang] }} </small>
                        </b-col>
                      </b-row>
                    </template>
                  </template>
                </template>
                
                <template v-if="d_bundleData.data['0']['56'] && d_bundleData.data['0']['56']['val'] && d_bundleData.data['0']['56']['val']['value'] && d_bundleData.data['0']['56']['val']['value'] == '1'">
                  <b-row class="mt-5 mb-2-5">
                    <b-col cols="12">
                      <div class="section-header-style">
                        <i class="fa fa-angle-right section-icon-style"></i>
                        <strong class="font-weight-bold-important"> {{ StoreLangTranslation.data['about_dataset'][StoreLang] }}</strong>
                      </div>
                    </b-col>
                  </b-row>

                  <!-- <b-row class="mt-5" v-if="d_wanalyzerProjectId">
                    <b-col cols="12">
                      <div class="preview-link-box-style">
                        <span class="agreement-link-style" @click="f_datasetPreview()">
                          <i class="fa fa-file-contract mr-1-25"></i>
                          {{ StoreLangTranslation.data['preview_dataset'][StoreLang] }}
                        </span>
                      </div>
                    </b-col>
                  </b-row> -->

                  <b-row class="mt-5" v-if="d_wanalyzerProjectId">
                    <b-col cols="12">
                      <span class="agreement-link-style" @click="f_datasetPreview()">
                        <i class="fa fa-table"></i>
                        {{ StoreLangTranslation.data['preview_dataset'][StoreLang] }}
                      </span>
                      <hr/>
                    </b-col>
                  </b-row>

                  <template v-if="d_userShopBundleWdm">
                    <b-card-header v-if="f_valValueCheck(d_bundleData.data['0'], ['39', '38', '36', '37'], ['46', '35'])" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                      <b-row>
                        <b-col sm="12" lg="8">
                          <h6>
                            <i class="fa fa-calculator"></i>
                            {{ StoreLangTranslation.data['dataset_features'][StoreLang] }}
                          </h6>
                        </b-col>
                        <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                      </b-row>
                    </b-card-header>
                    <b-card-body>
                      <b-row v-if="d_bundleData.data['0']['39'] && d_bundleData.data['0']['39']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['39']['name']['translation'][StoreLang] }}</strong><br/>
                          <div class="text-color-dark-gray" v-html="d_bundleData.data['0']['39']['lang'][StoreLang]"></div>
                        </b-col>
                      </b-row>
                      <b-row v-if="d_bundleData.data['0']['46'] && d_bundleData.data['0']['46']['val'] && d_bundleData.data['0']['46']['val']['value']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['46']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['46']['val']['translation'][StoreLang] }} </small>
                        </b-col>
                      </b-row>
                      <!-- <b-row v-if="d_bundleData.data['0']['38'] && d_bundleData.data['0']['38']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['38']['lang'][StoreLang] }} </small>
                        </b-col>
                      </b-row> -->
                      <b-row v-if="d_bundleData.data['0']['38'] && d_bundleData.data['0']['38']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}</strong><br/>
                          <div class="text-color-dark-gray" v-html="d_bundleData.data['0']['38']['lang'][StoreLang]"></div>
                        </b-col>
                      </b-row>
                      <b-row v-if="d_bundleData.data['0']['35'] && d_bundleData.data['0']['35']['val'] && d_bundleData.data['0']['35']['val']['value']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['35']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_userShopBundleWdm['0']['parameters']['35'].options[d_bundleData.data['0']['35']['val']['value']].translation[StoreLang] }} </small>
                        </b-col>
                      </b-row>
                      <b-row v-if="d_bundleData.data['0']['36'] && d_bundleData.data['0']['36']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['36']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['36']['val'] }} </small>
                        </b-col>
                      </b-row>
                      <b-row v-if="d_bundleData.data['0']['37'] && d_bundleData.data['0']['37']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['37']['val'] }} </small>
                        </b-col>
                      </b-row>
                    </b-card-body>

                    <b-card-header v-if="f_valValueCheck(d_bundleData.data['0'], ['52', '42'], ['40', '41'])" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                      <b-row>
                        <b-col sm="12" lg="8">
                          <h6>
                            <i class="fa fa-calculator"></i>
                            {{ StoreLangTranslation.data['dataset_subscriber_features'][StoreLang] }}
                          </h6>
                        </b-col>
                        <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                      </b-row>
                    </b-card-header>
                    <b-card-body>
                      <b-row v-if="d_bundleData.data['0']['40'] && d_bundleData.data['0']['40']['val'] && d_bundleData.data['0']['40']['val']['value']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['40']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['40']['val']['translation'][StoreLang] }} </small>
                        </b-col>
                      </b-row>
                      <b-row v-if="d_bundleData.data['0']['52'] && d_bundleData.data['0']['52']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['52']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['52']['lang'][StoreLang] }} </small>
                        </b-col>
                      </b-row>
                      <template v-if="d_bundleData.data['0']['41'] && d_bundleData.data['0']['41'].val && d_bundleData.data['0']['41'].val.value && d_bundleData.data['0']['41'].val.value == 1">
                        <b-row v-if="d_bundleData.data['0']['42'] && d_bundleData.data['0']['42']['val']" class="dataset-item-row-style">
                          <b-col sm="12" lg="12">
                            <i class="fa fa-angle-double-right product-icon-style"></i>
                            <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['42']['name']['translation'][StoreLang] }}</strong><br/>
                            <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['42']['lang'][StoreLang] }} </small>
                          </b-col>
                        </b-row>
                      </template>
                    </b-card-body>

                    <b-card-header v-if="d_bundleData.data['0']['57'] && d_bundleData.data['0']['57']['list'] && d_bundleData.data['0']['57']['list'].length > 0" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                      <b-row>
                        <b-col sm="12" lg="8">
                          <h6>
                            <i class="fa fa-calculator"></i>
                            {{ StoreLangTranslation.data['dataset_author_and_article_information'][StoreLang] }}
                          </h6>
                        </b-col>
                        <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                      </b-row>
                    </b-card-header>
                    <b-card-body>
                      
                      <template v-if="d_bundleData.data['0']['57'] && d_bundleData.data['0']['57']['list'] && d_bundleData.data['0']['57']['list'].length > 0">
                        <b-row class="dataset-item-row-style">
                          <b-col sm="12" lg="12">
                            <i class="fa fa-angle-double-right product-icon-style"></i>
                            <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['57']['name']['translation'][StoreLang] }}</strong><br/>
                          </b-col>
                        </b-row>
                        <b-row v-for="(author_item, author_index) in d_bundleData.data['0']['57']['list']" class="dataset-item-row-style">
                          <b-col sm="12" lg="12">
                            {{author_index + 1 + ') '}}
                            <small v-if="author_item['60'] && author_item['60']['val']" class="text-color-dark-gray"> {{ author_item['60']['val'] }} </small>{{' '}}
                            <small v-if="author_item['58'] && author_item['58']['val']" class="text-color-dark-gray"> {{ author_item['58']['val'] }} </small>{{' '}}
                            <small v-if="author_item['59'] && author_item['59']['val']" class="text-color-dark-gray"> {{ author_item['59']['val'] }} </small>{{', '}}
                            <small v-if="author_item['62'] && author_item['62']['lang'] && author_item['62']['lang'][StoreLang]" class="text-color-dark-gray"> {{ author_item['62']['lang'][StoreLang] }} </small>
                            <a v-if="author_item['63'] && author_item['63']['val']" :href="'https://orcid.org/' + author_item['63']['val']" target="_blank">
                              <img src="@/icon/orcid_id.png" style="width: 1.2em;">
                            </a>
                          </b-col>
                        </b-row>
                      </template>

                      <b-row v-if="d_bundleData.data['0']['43'] && d_bundleData.data['0']['43']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['43']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['43']['lang'][StoreLang] }} </small>
                        </b-col>
                      </b-row>
                      <b-row v-if="d_bundleData.data['0']['44'] && d_bundleData.data['0']['44']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['44']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['44']['val'] }} </small>
                        </b-col>
                      </b-row>
                      <b-row v-if="d_bundleData.data['0']['45'] && d_bundleData.data['0']['45']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['45']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['45']['lang'][StoreLang] }} </small>
                        </b-col>
                      </b-row>



                      <template v-if="d_bundleData.data['0']['64'] && d_bundleData.data['0']['64']['list'] && d_bundleData.data['0']['64']['list'].length > 0">
                        <b-row class="dataset-item-row-style">
                          <b-col sm="12" lg="12">
                            <i class="fa fa-angle-double-right product-icon-style"></i>
                            <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['64']['name']['translation'][StoreLang] }}</strong><br/>
                          </b-col>
                        </b-row>

                        <b-row v-for="(article_item, article_index) in d_bundleData.data['0']['64']['list']" class="dataset-item-row-style">
                          <b-col sm="12" lg="12">
                            <template v-if="article_item['65'] && article_item['65']['val'] && article_item['65']['val']['value'] && article_item['65']['val']['value'] == '1'">
                              <b-row v-if="article_item['49'] && article_item['49']['val']" class="dataset-item-row-style" style="background-color: #e1ecfb !important;">
                                <b-col sm="12" lg="12">
                                  <small class="text-color-dark-gray"> {{ article_item['49']['val'] }} </small>
                                  <span v-if="article_item['50'] && article_item['50']['val']">
                                    <a :href="f_addUtmSource(article_item['50']['val'])" target="_blank">
                                      <i class="fa fa-link"></i>
                                    </a>
                                  </span>
                                  <span v-if="article_item['48'] && article_item['48']['val']">
                                    [
                                      {{ article_item['48']['val'] }}
                                    ]
                                  </span>
                                </b-col>
                              </b-row>
                              
                              <b-row class="dataset-item-row-style">
                                <b-col sm="12" lg="12">
                                  <template v-if="article_item['66'] && article_item['66']['list'] && article_item['66']['list'].length > 0">
                                    <b-row v-for="(article_author_item, article_author_index) in article_item['66']['list']" class="dataset-item-row-style">
                                      <b-col sm="12" lg="12">
                                        {{article_author_index + 1 + ') '}}
                                        <small v-if="article_author_item['69'] && article_author_item['69']['val']" class="text-color-dark-gray"> {{ article_author_item['69']['val'] }} </small>{{' '}}
                                        <small v-if="article_author_item['67'] && article_author_item['67']['val']" class="text-color-dark-gray"> {{ article_author_item['67']['val'] }} </small>{{' '}}
                                        <small v-if="article_author_item['68'] && article_author_item['68']['val']" class="text-color-dark-gray"> {{ article_author_item['68']['val'] }} </small>{{', '}}
                                        <small v-if="article_author_item['71'] && article_author_item['71']['lang'] && article_author_item['71']['lang'][StoreLang]" class="text-color-dark-gray"> {{ article_author_item['71']['lang'][StoreLang] }} </small>
                                        <a v-if="article_author_item['72'] && article_author_item['72']['val']" :href="'https://orcid.org/' + article_author_item['72']['val']" target="_blank">
                                          <img src="@/icon/orcid_id.png" style="width: 1.2em;">
                                        </a>
                                      </b-col>
                                    </b-row>
                                  </template>
                                </b-col>
                              </b-row>
                              
                              <b-row v-if="article_item['73'] && article_item['73']['val']" class="dataset-item-row-style">
                                <b-col sm="12" lg="12">
                                  <i class="fa fa-angle-double-right product-icon-style"></i>
                                  <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['73']['name']['translation'][StoreLang] }}</strong><br/>
                                  <small class="text-color-dark-gray"> {{ article_item['73']['val'] }} </small>
                                </b-col>
                              </b-row>
                              
                            </template>
                          </b-col>
                        </b-row>
                      </template>
                    </b-card-body>


                    
                    <b-card-header v-if="f_valValueCheck(d_bundleData.data['0'], ['53', '54', '55'], [])" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                      <b-row>
                        <b-col sm="12" lg="8">
                          <h6>
                            <i class="fa fa-calculator"></i>
                            {{ StoreLangTranslation.data['ethics_committee_information'][StoreLang] }}
                          </h6>
                        </b-col>
                        <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                      </b-row>
                    </b-card-header>
                    <b-card-body>
                      <b-row v-if="d_bundleData.data['0']['53'] && d_bundleData.data['0']['53']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['53']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['53']['lang'][StoreLang] }} </small>
                        </b-col>
                      </b-row>
                      <b-row v-if="d_bundleData.data['0']['54'] && d_bundleData.data['0']['54']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['54']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['54']['val'] }} </small>
                        </b-col>
                      </b-row>
                      <b-row v-if="d_bundleData.data['0']['55'] && d_bundleData.data['0']['55']['val']" class="dataset-item-row-style">
                        <b-col sm="12" lg="12">
                          <i class="fa fa-angle-double-right product-icon-style"></i>
                          <strong class="dataset-label-style"> {{ d_userShopBundleWdm['0']['parameters']['55']['name']['translation'][StoreLang] }}</strong><br/>
                          <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['55']['val'] }} </small>
                        </b-col>
                      </b-row>
                    </b-card-body>


                    
                    <b-card-header v-if="f_valValueCheck(d_bundleData.data['0'], ['30', '31', '32'], ['29'])" header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                      <b-row>
                        <b-col sm="12" lg="8">
                          <h6>
                            <i class="fa fa-calculator"></i>
                            {{ StoreLangTranslation.data['dataset_contact_information'][StoreLang] }}
                          </h6>
                        </b-col>
                        <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                      </b-row>
                    </b-card-header>
                    <b-card-body>
                      <template v-if="d_bundleData.data['0']['29'] && d_bundleData.data['0']['29'].val && d_bundleData.data['0']['29'].val.value && d_bundleData.data['0']['29'].val.value == 1">
                        <b-row v-if="d_bundleData.data['0']['30'] && d_bundleData.data['0']['30']['val']" class="dataset-item-row-style">
                          <b-col sm="12" lg="12">
                            <i class="fa fa-angle-double-right product-icon-style"></i>
                            <strong class="dataset-label-style">{{ d_userShopBundleWdm['0']['parameters']['30']['name']['translation'][StoreLang] }}</strong><br/>
                            <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['30']['val'] }} </small>
                          </b-col>
                        </b-row>
                        <b-row v-if="d_bundleData.data['0']['31'] && d_bundleData.data['0']['31']['val']" class="dataset-item-row-style">
                          <b-col sm="12" lg="12">
                            <i class="fa fa-angle-double-right product-icon-style"></i>
                            <strong class="dataset-label-style">{{ d_userShopBundleWdm['0']['parameters']['31']['name']['translation'][StoreLang] }}</strong><br/>
                            <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['31']['val'] }} </small>
                          </b-col>
                        </b-row>
                        <b-row v-if="d_bundleData.data['0']['32'] && d_bundleData.data['0']['32']['val']" class="dataset-item-row-style">
                          <b-col sm="12" lg="12">
                            <i class="fa fa-angle-double-right product-icon-style"></i>
                            <strong class="dataset-label-style">{{ d_userShopBundleWdm['0']['parameters']['32']['name']['translation'][StoreLang] }}</strong><br/>
                            <small class="text-color-dark-gray"> {{ d_bundleData.data['0']['32']['lang'][StoreLang] }} </small>
                          </b-col>
                        </b-row>
                      </template>
                    </b-card-body>


                    

                  </template>
                  
                  <b-row class="mt-5">
                    <b-col cols="12">
                      <div class="agreement-link-box-style">
                        <span class="agreement-link-style" @click="f_agrementView()">
                          <i class="fa fa-file-contract mr-1-25"></i>
                          {{ StoreLangTranslation.data['click_for_agreement_preview'][StoreLang] }}
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                </template>
              </b-col>

              <b-col sm="12" lg="4">
                <div class="sidebar-box-style">
                  
                  <b-row class="mb-2-5">
                    <b-col sm="12" lg="12" class="text-center">
                      <template v-if="d_bundleData.data['0']['12'] && d_bundleData.data['0']['12']['val'] && d_bundleData.data['0']['12']['val']['value'] === '1'">
                        <div class="available-soon-button-style">
                          <i class="fa fa-shopping-basket mr-2"></i>
                          {{ StoreLangTranslation.data['available_soon'][StoreLang] }}
                        </div>
                      </template>
                      <template v-else>
                        <template v-if="d_addToShopcartLoading">
                          <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </template>
                        <template v-else>
                          <b-button v-if="f_addToShopcartEligible()" class="add-to-cart-button-style" @click="f_userShopCartBundleAdd()" size="lg">
                            <i class="fa fa-cart-plus mr-2"></i>
                            {{ StoreLangTranslation.data['add_to_shopping_cart'][StoreLang] }}
                          </b-button>
                        </template>
                      </template>
                    </b-col>
                  </b-row>

                  <hr class="hr-style">

                  <b-row class="mb-2-5">
                    <b-col sm="12" lg="12" class="text-center">
                      <b-button @click="f_supportModal()" size="md" class="product-representative-button-style">
                        <i class="fa fa-user-circle mr-2"></i>
                        {{ StoreLangTranslation.data['product_representative'][StoreLang] }}
                      </b-button>
                    </b-col>
                  </b-row>

                  <div v-if="d_bundleData.data['0']['56'] && d_bundleData.data['0']['56']['val'] && d_bundleData.data['0']['56']['val']['value'] == '1'">
                    <hr class="hr-style">
                    <b-row>
                      <b-col sm="12" lg="12" class="text-center">
                        <b-button @click="f_copyShortLink()" size="md" class="create-short-link-button-style">
                          <i class="fa fa-share-alt mr-2"></i>
                          {{ StoreLangTranslation.data['create_short_link'][StoreLang] }}
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <hr class="hr-transparent">
              </b-col>
            </b-row>
          </template>
      </b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-modal v-if="d_supportData.show" id="d_supportData_show" v-model="d_supportData.show" scrollable hide-footer :title="StoreLangTranslation.data['support_screen'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="lg">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <support-screen :p_supportData="d_supportData"></support-screen>
          </b-col>
        </b-row>
      </p>
      <p>
      <b-row>
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
          </b-col>
        </b-row>
      </p>
    </b-modal>
    <b-modal v-if="d_selectedProductData.show" id="d_selectedProductData_show" v-model="d_selectedProductData.show" scrollable hide-footer :title="StoreLangTranslation.data['product_ingredients'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="lg">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <shopcard-bundle-product-show :p_productData="d_selectedProductData.data"></shopcard-bundle-product-show>
          </b-col>
        </b-row>
      </p>
      <p>
      <b-row>
          <b-col sm="12" lg="6"></b-col>
          <b-col sm="12" lg="6" style="text-align: right;">
          </b-col>
        </b-row>
      </p>
    </b-modal>
    <b-modal v-if="d_agreementModal.show" id="d_agreementModal_show" v-model="d_agreementModal.show" scrollable hide-footer :title="StoreLangTranslation.data['agreement_preview'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <agreement-view :p_shopData="d_agreementModal.shop_data" :p_bundleData="d_agreementModal.bundle_data" :p_showMode="{'mode': 'approve'}"></agreement-view>
          </b-col>
        </b-row>
      </p>
    </b-modal>
    <b-modal v-if="d_datasetPreviewModal" id="d_datasetPreviewModal" v-model="d_datasetPreviewModal" scrollable hide-footer :title="StoreLangTranslation.data['preview_dataset'][StoreLang]" centered header-bg-variant="info" header-text-variant="dark" size="xl">
      <p>
        <b-row>
          <b-col sm="12" lg="12">
            <template v-if="d_datasetPreviewLoading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </template>
            <template v-else>
              <w-table2 style="transition: 2s; transform: none;" v-if="d_datasetWTable" :key="'dataset_view'" :p_tableDetails="d_datasetWTable"></w-table2>
            </template>
          </b-col>
        </b-row>
      </p>
    </b-modal>
    <b-toast id="copy-toast" variant="success" solid>
      {{ StoreLangTranslation.data['link_copied'][StoreLang] }}
    </b-toast>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as SupportScreen
} from '@/wam/components/widgets/SupportScreen';
import {
  default as ShopcardBundleProductShow
} from '@/components/widgets/ShopcardBundleProductShow';
import {
  default as AgreementView
} from '@/wam/components/widgets/AgreementView';
import {
  default as WTable2
} from '@/components/widgets/WTable2';
import { mapGetters } from 'vuex';
export default {
  name: 'product_details',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreShopCartList: 'StoreShopCartList',
    StoreCurrencyType: 'StoreCurrencyType',
  }),
  components: {
    PageInfo,
    SupportScreen,
    ShopcardBundleProductShow,
    AgreementView,
    WTable2,
  },
  props: {},
  data () {
    return {
      d_exchange_data: {},
      d_agreementModal: {
        'show': false,
        'shop_data': {},
        'bundle_data': {},
      },
      d_selectedProductData: {
        'data': '',
        'show': false
      },
      d_bundleProductList: [],
      d_loading: false,
      d_addToShopcartLoading: false,
      d_supportData: {
        'maximum_characters_name': 100,
        'maximum_characters_note': 500,
        'mail_status': true,
        'phone_status': true,
        'phone': '',
        'mail': '',
        'show': false,
        'edit_eligible': false,
        'operation_name': '',
        'operation_note': '',
        'operation_note_additional': '',
        'maximum_characters': 500,
        'subject': 'ürün destek'
      },
      d_bundleData: '',
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_userShopClientID: '',
      d_userShopBundleClientID: '',
      d_frontendList: [],
      d_usrShpList: [],
      d_userShopBundleWdm: '',
      d_discountLoading: false,
      d_bundleDiscounts: {},
      d_datasetPreviewModal: false,
      d_datasetWTable: '',
      d_datasetPreviewLoading: '',
      d_wanalyzerProjectId: '',
      d_institutionalDiscounts: false,
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_userShopBundleWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));

  },
  beforeMount () {},
  mounted: function () {
    if (this.$route.query.user_shop_client_id) {
      this.d_userShopClientID = this.$route.query.user_shop_client_id;
    }
    if (this.$route.query.user_shop_bundle_client_id) {
      this.d_userShopBundleClientID = this.$route.query.user_shop_bundle_client_id;
    }
    this.f_getBundleDetails();
    if (this.d_user && this.d_user.username) {
      this.f_checkDiscount();
    }
  },
  methods: {
    f_valValueCheck: function (search_data, val_variable_list, value_variable_list) {
      if (val_variable_list.length > 0) {
        for (let val_variable_item of val_variable_list) {
          let is_include = false;
          try {
            if (search_data[val_variable_item]['val']) {
              is_include = true;
            }
          } catch(err) {}
          if (is_include) {
            return true;
          }
        }
      }
      if (value_variable_list.length > 0) {
        for (let value_variable_item of value_variable_list) {
          let is_include = false;
          try {
            if (search_data[value_variable_item]['val']['value']) {
              is_include = true;
            }
          } catch(err) {}
          if (is_include) {
            return true;
          }
        }
      }
      return false;
    },
    f_addUtmSource: function (raw_link) {
      let link_with_utm = '';
      let x = raw_link.split('?');
      let fullHost = window.location.host;
      if (fullHost.startsWith("www.")) {
        fullHost = fullHost.replace("www.", "");
      }
      let domain = fullHost.split("/")[0];

      if (x.length == 1) {
        link_with_utm = x[0] + '?utm_source=' + domain;
      } else {
        link_with_utm = x[0] + '?utm_source=' + domain + '&' + x[1];
      }
      return link_with_utm;
    },
    f_copyShortLink: function () {
      const origin = window.location.origin;
      const newPath = '/dataset?did=' + this.d_bundleData.id;
      const newUrl = origin + newPath;

      navigator.clipboard.writeText(newUrl)
        .then(() => {
          this.$bvToast.show('copy-toast');
        })
        .catch(err => {
          // Hata bildirimi
          this.$bvToast.toast(this.StoreLangTranslation.data['process_completed'][this.StoreLang] + err, {
            title: "Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 3000
          });
        });
    },
    f_addToShopcartEligible: function () {
      // normalde default olarak bundle sepete eklenebilir şekilde çalışıyor. Ama can_customer_add_to_shopcart ekleyemez şeklinde tanımlandıysa buton gösterilmiyor.
      let view_eligible = true;
      try {
        let can_customer_add_to_shopcart = this.d_bundleData['data']['0']['21']['val']['value'];
        if (can_customer_add_to_shopcart === '1') {
          view_eligible = false;
        }
      } catch(err) {}
      return view_eligible;
    },
    f_agrementView: function () {
      this.d_agreementModal.shop_data = {'client_id': this.d_userShopClientID };
      this.d_agreementModal.bundle_data = {'client_id': this.d_userShopBundleClientID, 'agreement_client_id': '' };
      this.d_agreementModal.show = true;
    },
    f_datasetPreview: function () {
      this.d_datasetPreviewModal = true;
      this.d_datasetPreviewLoading = true;
      let query = 'project_id=' + this.d_wanalyzerProjectId;
      let data = {};
      ServiceFunctions.wanalyzer_project_dataset_preview_get(query, data)
        .then(resp => {
          this.d_datasetPreviewLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.wtable) {
              this.d_datasetWTable = resp.data.wtable;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_openProductIngredients: function (product_data) {
      this.d_selectedProductData.show = true;
      this.d_selectedProductData.data = product_data;
    },
    f_getOptionLabel: function (option_value, options) {
      // console.log('option_value : ', option_value);
      // console.log('options : ', options);
      let option_label = '';
      for (let i in options) {
        if (options[i].value === option_value) {
          option_label = options[i].translation[this.StoreLang];
          break;
        }
      }
      return option_label;
    },
    f_calculateProductTotalPrice: function (bundle_products) {
      let currency_text = this.StoreCurrencyType.label;
      let total_amount = 0;
      let exchange_amount = 1;
      let tl_price = null;
      let non_tl_price = null;
      let product_cur_type = null;
      let cur_fixed = true;
      for (let product_index in bundle_products) {

        tl_price = null;
        non_tl_price = null;
        try {//currency_list
          for (let currency_amount_index in bundle_products[product_index].product.data['0']['25'].list) {
            let currency_amount_item = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index];
            product_cur_type = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index]['26']['val']['value'];
            let exchange_cur_type = this.d_exchange_data['system'][product_cur_type];//Buradan ürünün para birimi geliyor. 0,1..
            let page_cur_type = this.d_exchange_data['system'][this.StoreCurrencyType.value];//Buradan sayfanın par birimi geliyor 0,1..
            if (page_cur_type != null){//Kur dosyamızda örneğin sayfa TL, bizde TL varmı
              if (exchange_cur_type != null){//Ürün para birimi örneğin USD, bizde USD varmı
                if(this.d_exchange_data[page_cur_type] != null){//Sayfaya göre Kur değerlerimiz varmı? sayfa TL, TL için kur değerleri varmı
                  exchange_amount = parseFloat(this.d_exchange_data[page_cur_type][exchange_cur_type]);
                  //Buradada exchange_data['sayfa_para_birimi('TL')'][ürün_para_birimi('Dolar')] = 43,...
                }
              }
            }
            if(currency_amount_item['64'] && currency_amount_item['64']['val'] && currency_amount_item['64']['val']['value'] &&currency_amount_item['64']['val']['value'] === '1'){
              cur_fixed = false;
            }
            else{
              cur_fixed = true;
            }
            //Gelen ürünün para birimine göre atama
            if(product_cur_type === '0'){ 
              tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            else{
              non_tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            }
            try {
              if (cur_fixed){//Kur sabit/fixed
                  if (this.StoreCurrencyType.value ==='0' && tl_price !== null) {
                    total_amount += tl_price;
                  }
                  else if (this.StoreCurrencyType.value ==='1' && non_tl_price !== null){
                    total_amount += non_tl_price;
                  }
                  else{
                    total_amount += (non_tl_price * exchange_amount) + (tl_price * exchange_amount);
                  }
                }
              else{//Kur değeri Güncel
    
                if(this.StoreCurrencyType.value ==='0'){
                  //Sayfa para birimi tl ise
                  if(tl_price !== null){
                    total_amount += tl_price;
                  }
                  else{
                    total_amount += non_tl_price * exchange_amount;
                  }
                }
                else{
                  //sayfa para birimide dolar ise
                  if(non_tl_price !== null){
                    total_amount += non_tl_price;
                  }
                  else{
                    total_amount += tl_price * exchange_amount;
                  }
                  
                }
              }
                
            } catch(err) {}
          
        } catch(err) {}
      }
      return total_amount.toFixed(2) + ' ' + currency_text; 
    },
    f_calculateProductTotalPriceWithDiscount: function (bundle_products) {
      let max_discount_percent = 0;
      if (this.d_bundleDiscounts && this.d_bundleDiscounts[this.d_userShopBundleClientID]) {
        max_discount_percent = this.d_bundleDiscounts[this.d_userShopBundleClientID]['max_discount_percent'];
      }
      let currency_text = this.StoreCurrencyType.label;
      let total_amount = 0;
      let tl_price = null;
      let non_tl_price = null;
      let exchange_amount = 1;
      let product_cur_type = null;
      let cur_fixed = true;
      for (let product_index in bundle_products) {
        tl_price = null;
        non_tl_price = null;
        try {//currency_list
          for (let currency_amount_index in bundle_products[product_index].product.data['0']['25'].list) {
            let currency_amount_item = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index];
            product_cur_type = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index]['26']['val']['value'];
            let exchange_cur_type = this.d_exchange_data['system'][product_cur_type];
            let page_cur_type = this.d_exchange_data['system'][this.StoreCurrencyType.value];


            if (page_cur_type != null){
              if (exchange_cur_type != null){
                if(this.d_exchange_data[page_cur_type] != null){
                  exchange_amount = parseFloat(this.d_exchange_data[page_cur_type][exchange_cur_type]);
                }
              }
            }
            if(currency_amount_item['64'] && currency_amount_item['64']['val'] && currency_amount_item['64']['val']['value'] &&currency_amount_item['64']['val']['value'] === '1'){
              cur_fixed = false;
            }
            else{
              cur_fixed = true;
            }
            //Gelen ürünün para birimine göre atama
            if(product_cur_type === '0'){ 
              tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            else{
              non_tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            }
            try {
              if (cur_fixed){//Kur sabit/fixed
                  if (this.StoreCurrencyType.value ==='0' && tl_price !== null) {
                    total_amount += tl_price;
                  }
                  else if (this.StoreCurrencyType.value ==='1' && non_tl_price !== null){
                    total_amount += non_tl_price;
                  }
                  else{
                    total_amount += (non_tl_price * exchange_amount) + (tl_price / exchange_amount);
                  }
                }
                else{//Kur değeri Güncel
    
                  if(this.StoreCurrencyType.value ==='0'){
                    //Sayfa para birimi tl ise
                    if(tl_price !== null){
                      total_amount += tl_price;
                    }
                    else{
                      total_amount += non_tl_price * exchange_amount;
                    }
                  }
                  else{
                    //sayfa para birimide dolar ise
                    if(non_tl_price !== null){
                      total_amount += non_tl_price;
                    }
                    else{
                      total_amount += tl_price / exchange_amount;
                    }
                  }
                }  
            } catch(err) {}
        } catch(err) {}
      }
      total_amount = total_amount * ((100 - max_discount_percent) / 100);
      return total_amount.toFixed(2) + ' ' + currency_text;
    },
    f_showCheckProduct: function (product_data) {
      let show_product = true;
      try {
        if (product_data.data['0']['48']['val']['value'] === '0') {
          show_product = false;
        }
      } catch(err) {}
      try {
        if (product_data.data['0']['0']['val']['value'] !== '1') {
          show_product = false;
        }
      } catch(err) {}
      return show_product;
    },
    f_supportModal: function () {
      if (this.d_user) {
        this.d_supportData.show = true;
        this.d_supportData.operation_name = this.d_bundleData.data['0']['1']['lang'][this.StoreLang];
        this.d_supportData.operation_note = this.StoreLangTranslation.data['i_want_to_get_information_about_bundle_by_online_meeting'][this.StoreLang];
        this.d_supportData.user_shop_bundle_client_id = this.d_userShopBundleClientID;
      } else {
        this.f_login();
      }
    },
    f_getBundleDetails: function () {
      this.d_loading = true;
      let query = 'user_shop_client_id=' + this.d_userShopClientID;
      query += '&user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      let data = {};
      ServiceFunctions.bundle_details(query, data)
        .then(resp => {
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.data) {
              this.d_bundleData = resp.data.data;
              this.d_bundleProductList = resp.data.product_list;
              this.d_exchange_data = resp.data.exchange_data;
              this.d_wanalyzerProjectId = '';
              try {
               this.d_wanalyzerProjectId = this.d_bundleProductList[0]['product']['data']['0']['37']['val'];
              } catch(err) {}
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_checkDiscount: function () {
      this.d_discountLoading = true;
      let query = 'user_client_id=' + this.d_user.username;
      let data = {
        'user_shop_bundle_list': [this.d_userShopBundleClientID]
      };
      ServiceFunctions.check_discount(query, data)
        .then(resp => {
          this.d_discountLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.bundle_discount_list) {
              this.d_bundleDiscounts = resp.data.bundle_discount_list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_login: function () {
      this.$router.push({ 'path': '/login', 'query': {} });
    },
    f_userShopCartBundleAdd: function () {
      if (this.d_user && this.d_user.username) {
        this.d_addToShopcartLoading = true;
        let query = 'user_client_id=' + this.d_user.username;
        query += '&add_bundle_count=1';
        query += '&user_shop_client_id=' + this.d_userShopClientID;
        let data = {};
        if (this.d_userShopBundleClientID) {
          query += '&user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
        }
        ServiceFunctions.user_shopcart_bundle_add(query, data)
          .then(resp => {
            this.d_addToShopcartLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              if (resp.data.cannot_add == '1') {
                alert(this.StoreLangTranslation.data['already_has_institutional_product'][this.StoreLang]);
              } else {
                alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
                if (this.StoreShopCartList.status === 1) {
                  this.$store.commit('MutationShopCartList', { 'status': 0, 'data': this.StoreShopCartList.data });
                } else {
                  this.$store.commit('MutationShopCartList', { 'status': 1, 'data': this.StoreShopCartList.data });
                }
              }
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      } else {
        this.f_login();
      }
    },
  },
  watch: {}
};

</script>

<style scoped>
/* Genel Stil Tanımları */
.font-size-base {
    font-size: 16px;
}
.text-align-left {
    text-align: left;
}
.text-align-right {
    text-align: right;
}
.text-color-dark-gray {
    font-size: 15px;
    color: #334155; /* slate-700 */
}
.font-weight-bold-important {
    font-weight: 700 !important;
}

/* Aralık (Margin/Padding) Kısaltmaları */
.mb-3-75 {
    margin-bottom: 15px !important;
}
.mt-5 {
    margin-top: 20px !important;
}
.mb-2-5 {
    margin-bottom: 10px !important;
}
.mr-1-25 {
    margin-right: 5px !important;
}
.mr-2 {
    margin-right: 8px !important;
}

/* Kategor/Başlık Stilleri */
.category-tag-style {
    background-color: #e2f3ff; /* sky-100 */
    padding: 8px 15px;
    border-radius: 12px;
    font-size: 14px;
    color: #0369a1; /* sky-700 dark */
    font-weight: 600;
    text-align: left;
}
.bundle-title-box-style {
    margin-bottom: 20px;
    text-align: left;
    background: #f0f9ff; /* sky-50 */
    padding: 20px;
    border-radius: 14px;
    box-shadow: 0 4px 12px rgba(30, 64, 175, 0.1);
    font-weight: 700;
    border: 1px solid #dbe3ef; /* slate-200 */
}
.bundle-title-h2-style {
    margin: 0;
    font-size: 24px;
    color: #0f172a; /* slate-900 */
}

/* Bölüm Başlıkları (Section Headers) Stilleri */
.section-header-style {
    text-align: left;
    background-color: #e6fffa; /* teal-50 */
    border-radius: 8px;
    padding: 10px 15px;
    border-left: 5px solid #00c49a; /* teal-400/500 */
    color: #00796b; /* teal-700 */
}
.section-icon-style {
    margin-right: 8px;
}

/* Ürün Listesi Stilleri */
.product-item-row-style {
    margin: 0 0 8px 0;
    padding: 8px 15px;
    border-bottom: 1px solid #f1f5f9; /* slate-100 */
    align-items: center;
}
.product-icon-style {
    color: #00c49a; /* teal-400/500 */
    margin-right: 8px;
    font-size: 14px;
}
.price-style {
    color: #1e40af; /* indigo-700 */
    font-weight: 700;
}

/* Özellik (Feature) Listesi Stilleri */
.feature-item-row-style {
    margin: 0 0 5px 0;
    padding: 5px 15px;
    border-bottom: 1px dashed #f1f5f9; /* slate-100 */
    text-align: left;
}
.feature-highlight-icon {
    color: #00c49a; /* teal-400/500 */
    margin-right: 8px;
}
.feature-general-icon {
    font-size: 10px;
    color: #00c49a; /* teal-400/500 */
    margin-right: 8px;
}
.link-style {
    color: #1e40af; /* indigo-700 */
    font-weight: 500;
}

/* Veri Kümesi (Dataset) Stilleri */
.dataset-item-row-style {
    margin: 0 0 5px 0;
    padding: 5px 15px;
    border-bottom: 1px dashed #f1f5f9; /* slate-100 */
    text-align: left;
}
.dataset-label-style {
    font-weight: 800 !important;
    /*color: #1e40af; */
    margin-right: 8px;
}

.preview-link-box-style {
    
    border-radius: 8px;
    background-color: #f0f9ff; /* sky-50 */
    padding: 10px 15px;
    border: 1px solid #dbe3ef; /* slate-200 */
}

/* Sözleşme Önizleme Stilleri */
.agreement-link-box-style {
    text-align: right;
    border-radius: 8px;
    background-color: #f0f9ff; /* sky-50 */
    padding: 10px 15px;
    border: 1px solid #dbe3ef; /* slate-200 */
}
.agreement-link-style {
    cursor: pointer;
    color: #1e40af; /* indigo-700 */
    font-weight: 600;
}

/* Sidebar (Sağ Kolon) Stilleri */
.sidebar-box-style {
    border: 1px solid #dbe3ef; /* slate-200 */
    border-radius: 14px;
    padding: 20px;
    background: #f8fafc; /* slate-50 */
    box-shadow: 0 2px 8px rgba(30, 64, 175, 0.06);
}
.hr-style {
    border-color: #e2e8f0; /* slate-200 */
}
.hr-transparent {
    border-color: transparent;
}

/* Buton Stilleri */

/* Sepete Ekle Butonu */
.add-to-cart-button-style {
    border: none;
    color: white;
    background: linear-gradient(to bottom right, #1FA2FF, #12D8FA);
    padding: 10px 18px;
    border-radius: 12px;
    box-shadow: 0 2px 6px rgba(3, 105, 161, 0.25);
    font-weight: 700;
    transition: all 0.2s ease-in-out; /* Geçiş animasyonu ekledik */
}
.add-to-cart-button-style:hover {
    /* Hover'da rengi biraz koyulaştırarak derinlik hissi verelim */
    background: linear-gradient(to bottom right, #1091e9, #05c2e0);
    box-shadow: 0 4px 12px rgba(3, 105, 161, 0.4);
    transform: translateY(-1px); /* Hafif yukarı kaydırma efekti */
}

/* Ürün Temsilcisi Butonu */
.product-representative-button-style {
    background-color: #cbd5e1 !important; /* slate-300 */
    color: #334155 !important; /* slate-700 */
    border: none;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s;
}
.product-representative-button-style:hover {
    background-color: #94a3b8 !important; /* slate-400 */
    /*color: white !important;*/
    box-shadow: 0 2px 4px rgba(51, 65, 85, 0.2);
}

/* Kısa Link Oluştur Butonu */
.create-short-link-button-style {
    background-color: #94a3b8 !important; /* slate-400 */
    color: white !important;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s;
}
.create-short-link-button-style:hover {
    background-color: #64748b !important; /* slate-500 */
    box-shadow: 0 2px 4px rgba(51, 65, 85, 0.2);
}

/* Sözleşme Önizleme Linki (span) için Hover */
.agreement-link-style {
    cursor: pointer;
    color: #1e40af; /* indigo-700 */
    font-weight: 600;
    transition: color 0.15s;
}
.agreement-link-style:hover {
    color: #3b82f6; /* blue-500 */
    text-decoration: underline;
}

.underlined-price {
  font-size: 14px;
  color: black;
  position: relative;
  display: inline-block;
  margin-left: 10px;
}

.underlined-price::after {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;           /* Metnin tam ortası */
  width: 100%;
  height: 2px;
  background: red;
  transform: rotate(-25deg) translateY(-50%);
  transform-origin: center;
  pointer-events: none;
}

</style>